export default "__VITE_ASSET__30d0d6a3__"